
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/baf",
      function () {
        return require("private-next-pages/au/baf/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/baf"])
      });
    }
  